import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MasterDataEffects } from './effects/master-data.effects';
import masterDataReducer, {
  name as masterDataFeatureName
} from './features/master-data.slice';
import {
  MASTER_DATA_CONFIG,
  MASTER_DATA_CONSTANTS
} from './master-data.config';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(masterDataFeatureName, masterDataReducer),
    EffectsModule.forFeature([MasterDataEffects])
  ],
  providers: [{ provide: MASTER_DATA_CONFIG, useValue: MASTER_DATA_CONSTANTS }]
})
export class MasterDataModule {}
